// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3efTV","footer":"ModalUpdate_footer__2jJVr"};